import React from "react";
import { useLocation } from "react-router-dom";
import DashboardHeader from "./Dashboard";
import GoodsInHeader from "./GoodsIn";
import AdminHeader from './Admin';
import { SearchHeader } from "./search";
import { EditDispatchHeader } from "./editDispatch";
import { EditGoodsInHeader } from "./editGoodsIn";

function Header({ RightSidebarOpenCloseFlag }) {
  const Location = useLocation();


  if (Location.pathname == "/app/dashboard") {
    return <DashboardHeader RightSidebarOpenCloseFlag={RightSidebarOpenCloseFlag} />;
  } else if (Location.pathname == "/app/goodsin/list" || Location.pathname == "/app/dispatchorders/list" || Location.pathname == "/app/reports/list" || Location.pathname == "/app/report/list" || Location.pathname == "/app/iteminventoryreport/list" || Location.pathname == "/app/reconciliation/list") {
    return <GoodsInHeader />;
  }
  else if (Location.pathname == "/app/admin/list") {
    return <AdminHeader RightSidebarOpenCloseFlag={RightSidebarOpenCloseFlag} />;
  }
  else if (Location.pathname == "/app/searchgoods/list") {
    return <SearchHeader />;
  } else if (Location.pathname.includes("/app/dispatchorders/detail")) {
    return <EditDispatchHeader />
  } else if (Location.pathname.includes("/app/goodsin/detail")) {
    return <EditGoodsInHeader />
  }
  else {
    return <DashboardHeader />;
  }

}

export default Header;
